import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { RichTextField } from 'react-admin';

const styles = {
  main: {
    margin: '1em 0',
    '& > span > div': {
      marginBottom: '1em',
    },
  },
};

const StyledRichTextField = withStyles(styles)(({ classes, ...props }) => (
  <RichTextField className={classes.main} {...props} />
));


export default StyledRichTextField;



// WEBPACK FOOTER //
// ./src/components/StyledRichTextField.js